import React, { useEffect, useState } from 'react';
import { IInvoiceFullObject } from '../Interfaces/IInvoice';
import {
  alpha,
  Box,
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  useTheme,
} from '@mui/material';
import { InvoicePaidPlanAddDialog } from './InvoicePaidPlanAddDialog';
import { IInvoicePaidPlan } from '../Interfaces/IInvoicePaidPlan';
import { InvoicePaidPlanRow } from './InvoicePaidPlanRow';

interface IProps {
  editInvoice: IInvoiceFullObject;
  setEditInvoice: Function;
}

export const InvoicePaidPlanTable: React.FC<IProps> = ({
  editInvoice,
  setEditInvoice,
}) => {
  const theme = useTheme();
  //const [invPaidPlans,setInvPaidPlans] = useState(editInvoice.InvoicePaidPlans);
  const invPaidPlans = editInvoice.InvoicePaidPlans;
  const setInvPaidPlans = (invPaidPlansUpdate: IInvoicePaidPlan[]) => {
    setEditInvoice({
      ...editInvoice,
      InvoicePaidPlans: [...invPaidPlansUpdate],
    });
  };

  //
  const [isOpenAddDialog, setIsOpenAddDialog] = useState(false);
  const [allowWarningPlanTotal, setAllowWarningPlanTotal] = useState(false);

  const totalPlan = invPaidPlans
    .map(plan => plan.PaidValue)
    .reduce((a, b) => a + b, 0);

  const isSameValue =
    invPaidPlans.length === 0 || editInvoice.Total === totalPlan;

  const handleAdd = () => {
    if (invPaidPlans.length === 0) {
      setIsOpenAddDialog(true);
    }
  };

  useEffect(() => {
    setAllowWarningPlanTotal(true);
  }, [invPaidPlans.length]);

  return (
    <>
      {isOpenAddDialog && (
        <InvoicePaidPlanAddDialog
          editInvoice={editInvoice}
          invPaidPlans={invPaidPlans}
          setInvPaidPlans={setInvPaidPlans}
          setIsOpen={setIsOpenAddDialog}
        />
      )}

      <Typography>
        Zahlungenplan
        <Button sx={{ float: 'right' }} variant='outlined' onClick={handleAdd}>
          Zahlungsplan hinzufügen
        </Button>
      </Typography>

      <Table size='small'>
        <TableHead>
          <TableRow>
            <TableCell>Ratenzahlung</TableCell>
            <TableCell>Frist bis</TableCell>
            <TableCell>Summe</TableCell>
            <TableCell width={120}>Aktionen</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {invPaidPlans.map((invPaidPlan, idx) => (
            <InvoicePaidPlanRow
              key={`invpaidplan-${invPaidPlan.idInvoicePaidPlan}`}
              index={idx}
              editInvoice={editInvoice}
              setEditInvoice={setEditInvoice}
              invPaidPlan={invPaidPlan}
              invPaidPlans={invPaidPlans}
              setInvPaidPlans={setInvPaidPlans}
            />
          ))}
          <TableRow
            sx={{
              backgroundColor:
                allowWarningPlanTotal && !isSameValue
                  ? alpha(theme.palette.error.light, 0.2)
                  : undefined,
            }}
          >
            <TableCell
              colSpan={4}
              sx={{
                width: '100%',
              }}
            >
              <Box
                sx={{
                  float: 'right',
                  display: 'flex',
                  gap: 5,
                }}
              >
                {allowWarningPlanTotal && !isSameValue && (
                  <Typography>
                    Summe stimmt mit{' '}
                    {(totalPlan - Number(editInvoice.Total)).toLocaleString(
                      'de-DE',
                      {
                        style: 'currency',
                        currency: 'EUR',
                      }
                    )}{' '}
                    nicht mit der Rechnungssumme überein!
                  </Typography>
                )}
                <Typography
                  sx={{
                    fontWeight: 'bold',
                  }}
                >
                  {totalPlan.toLocaleString('de-DE', {
                    style: 'currency',
                    currency: 'EUR',
                  })}
                </Typography>
              </Box>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </>
  );
};
